module.exports = __webpack_public_path__ + "img/top-left.369a3b62.png";